var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPin1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 15.5516L8.43849 15.1687C12.1258 11.949 14 9.13768 14 6.6665C14 3.16695 11.2686 0.666504 8 0.666504C4.73137 0.666504 2 3.16695 2 6.6665C2 9.13768 3.87421 11.949 7.56151 15.1687L8 15.5516ZM8 13.7754C4.87107 10.9555 3.33333 8.56599 3.33333 6.6665C3.33333 3.93091 5.44274 1.99984 8 1.99984C10.5573 1.99984 12.6667 3.93091 12.6667 6.6665C12.6667 8.56599 11.1289 10.9555 8 13.7754ZM8 3.33317C9.84095 3.33317 11.3333 4.82555 11.3333 6.6665C11.3333 8.50745 9.84095 9.99984 8 9.99984C6.15905 9.99984 4.66667 8.50745 4.66667 6.6665C4.66667 4.82555 6.15905 3.33317 8 3.33317ZM6 6.6665C6 5.56193 6.89543 4.6665 8 4.6665C9.10457 4.6665 10 5.56193 10 6.6665C10 7.77107 9.10457 8.6665 8 8.6665C6.89543 8.6665 6 7.77107 6 6.6665Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin1);
export default __webpack_public_path__ + "static/media/pin-1.aca8089fa1e8e159073cd3b8d322ccdb.svg";
export { ForwardRef as ReactComponent };